import AbstractAPI from '@/services/api/AbstractAPI';

export default class LeadsApi extends AbstractAPI {

  constructor(client, options) {
    super(client, options, '/lead');
  }

  async leads(filters) {
    return this.makeRequest('/inventory', 'get', {params: filters});
  }

  async update(id, data) {
    return this.makeRequest(`/inventory/${id}`, 'put', data);
  }

  async setLeadAlertStatus(status) {
    await this.makeRequest('/alerts', 'put', {status});
  }

  async getLeadAlertStatus() {
    return this.makeRequest('/alerts', 'get');
  }

  async toggleLeadArchived(id) {
    return this.makeRequest(`/toggle-archive/${id}`, 'put');
  }

  async getLeadWorkTypes() {
    return this.makeRequest('/inventory/work-types', 'get');
  }

  async getLead(code) {
    return this.makeRequest(`/find/${code}`, 'get');
  }

  async addNote(text, id) {
    return this.makeRequest(`/add-note/${id}`, 'post', {text});
  }

  async removeNote(noteId,  leadId) {
    return this.makeRequest(`/remove-note/${leadId}`, 'post', {noteId});
  }

  async reportLead(reason, comment, id) {
    return this.makeRequest(`/report/${id}`, 'post', {comment, reason, actionType: 'report'});
  }

  async appealLead(comment, id) {
    return this.makeRequest(`/report/${id}`, 'post', {comment, actionType: 'appeal'});
  }

  async marketplace(filters) {
    return this.makeRequest('/marketplace', 'get', {params: filters});
  }

  async marketplaceWorkTypes() {
    return this.makeRequest('/marketplace/work-types', 'get');
  }

  async getLeadQuestions(id) {
    return this.makeRequest(`/questions/${id}`, 'get');
  }

  async buySingle(id) {
    return this.makeRequest(`/accept/${id}`, 'put');
  }

  async buyBulk(leads) {
    return this.makeRequest(`/accept-bulk`, 'post',{leads});
  }

  async reject(id) {
    return this.makeRequest(`/reject/${id}`, 'put');
  }

  async rejectReasons() {
    return this.makeRequest(`/reject-reasons`, 'get');
  }

  async rejectFeedback(reason, enquiryId) {
    return this.makeRequest(`/reject-reason/${enquiryId}/${reason}`, 'put');
  }

  async checkAvailability(enquiryId) {
    return this.makeRequest(`/availability/${enquiryId}`, 'get')
  }

  async markViewed(enquiryId) {
    return this.makeRequest(`/mark-viewed/${enquiryId}`, 'put')
  }

  async getLeadNotifications() {
    return this.makeRequest(`/notifications`, 'get')
  }

  async dismissLeadNotifications(leads) {
    return this.makeRequest(`/notifications/dismiss`, 'put', {leads})
  }

  async markLeadNotificationsRead(leads) {
    return this.makeRequest(`/notifications/mark-read`, 'put', {leads})
  }

  async bulkArchive(leads) {
    return this.makeRequest('/bulk-archive', 'put', {leads})
  }

  async offerFinance(lead) {
    return this.makeRequest(`/offer-finance/${lead}`, 'post');
  }

  async offerFinanceExternal(email, title, firstName, lastName, siteId) {
    return this.makeRequest('/offer-finance-external', 'post', {
      email,
      title,
      first_name: firstName,
      last_name: lastName,
      siteId: siteId,
    });
  }
}
